/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GantryStartupLogsOutput } from '../../models/gantry-startup-logs-output';

export interface GetGantryStartupLogs$Params {
  SerialNumber: string;
  MaterialNumber: number;
  EventSource: string;
}

export function getGantryStartupLogs(http: HttpClient, rootUrl: string, params: GetGantryStartupLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<GantryStartupLogsOutput>> {
  const rb = new RequestBuilder(rootUrl, getGantryStartupLogs.PATH, 'get');
  if (params) {
    rb.path('SerialNumber', params.SerialNumber, {});
    rb.path('MaterialNumber', params.MaterialNumber, {});
    rb.path('EventSource', params.EventSource, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GantryStartupLogsOutput>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getGantryStartupLogs.PATH = '/api/CTSystemStatus/gantrystartuplogs/{SerialNumber}/{MaterialNumber}/{EventSource}';
getGantryStartupLogs.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getGantryStartupLogs.ROOTURL = '/ctsystem';
